var map = {
	"./area_current.svg": 68412,
	"./card_current.svg": 39829,
	"./home_current.svg": 12894,
	"./menu_current.svg": 23546,
	"./prizes_current.svg": 40876,
	"./rank_current.svg": 79761
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 68795;